<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="javascript:void(0)">
              新闻动态
            </a>
          </li>
          <li>
            <a href="javascript:void(0)">
              关于我们
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" @click="openChatbox">
              代理合作
            </a>
          </li>
          <li>
            <a href="javascript:void(0)" @click="openChatbox">
              联系我们
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, made with <md-icon>favorite</md-icon> by
        <a href="http://ynbtech.com/" target="_blank">YNBTECH</a>.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  methods: {
    openChatbox() {
      if (window.tidioChatApi) {
        window.tidioChatApi.open();
      }
    },
  },
};
</script>
<style></style>
